import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { DrillTableDataset } from 'app/model/dataset/drill.dataset';
import { DrillLinkedService } from 'app/model/linkedservice/drill.linkedservice';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';
import { format } from 'app/shared/utils/string.util';

export const drillTableMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(DrillTableDataset).name,
    displayName: format(stringResources.ModelName_DisplayTextLegacyTemplate, stringResources.Drill_DisplayText),
    supportLinkedServiceTypes: [Metamodel.modelFor(DrillLinkedService).name],
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-drill'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    splitTablePath: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['Database']
};
